/**
 * @file
 * Header helpers for the tfal theme.
 */

const { resetCards } = require("./resource/utils");

(($, Drupal, once) => {
  const header = document.getElementsByTagName("header")[0];
  const main = document.querySelectorAll("header.has-banner ~ main")[0];
  const navBar = header.querySelector(".navbar");
  const navbarBase = navBar.getAttribute("data-navbar-base");
  const navbarOpenClass = "navbar-open";

  // Adds class to parent .dropdown-menu when .dropdown-items clicked.
  const elements = header.querySelectorAll("[data-bs-toggle='dropdown']");
  Array.from(elements).forEach((element) => {
    element.addEventListener("click", () => {
      const ddMenu = element.parentNode.parentNode;
      if (element.getAttribute("aria-expanded") === "true") {
        ddMenu.classList.add("showing");
        // When main links are clicked, remove all .showing classes.
        if (element.classList.contains("nav-link")) {
          const showingElements = document.querySelectorAll(".showing");
          showingElements.forEach((item) => {
            item.classList.remove("showing");
          });
        }
      } else {
        ddMenu.classList.remove("showing");
      }
    });
  });

  // Mobile -> Desktop resize; collapse nav, fix header offset.
  window.addEventListener("resize", () => {
    const headerHeight = header.offsetHeight;
    if (window.innerWidth >= 991) {
      if (document.body.classList.contains(navbarOpenClass)) {
        document.body.classList.remove(navbarOpenClass);
        $("#navbarHeader").collapse("hide");

        // Set header height variable.
        if (typeof main !== "undefined" && main !== undefined) {
          main.style.marginTop = `${-headerHeight}px`;
        }
      }
    }
  });

  // Shows the menu only after loading the page.
  window.addEventListener("load", () => {
    $("header").css("visibility", "visible");
  });

  // Accessibility: Escape key with navbar open, close nav.
  document.body.addEventListener("keyup", (e) => {
    if (
      e.key === "Escape" &&
      document.body.classList.contains(navbarOpenClass)
    ) {
      document.body.classList.remove(navbarOpenClass);
      $("#navbarHeader").collapse("hide");
    }
  });

  /**
   * When clicking the close button, trigger the back button.
   */
  Drupal.behaviors.tfalHeader = {
    attach: function attach(context) {
      // Initiate Google Translate widget.
      $(
        once("google_translate_element", "#google_translate_element", context)
      ).each((key, element) => {
        const translate = setInterval(() => {
          if (google.translate) {
            google.translate.TranslateElement(
              { pageLanguage: "en" },
              "google_translate_element"
            );
            element
              .querySelector("select")
              .classList.add(
                "form-select",
                "form-select-sm",
                "ff-headings",
                "fw-bold",
                "opacity-100"
              );
            clearInterval(translate);

            // Set timeout.
            setTimeout(() => {
              // Observe changes to the element.
              const config = {
                childList: true,
                subtree: true,
              };
              const callback = () => {
                resetCards(
                  document.querySelectorAll(".view-resource-centre .card")
                );
              };
              const observer = new MutationObserver(callback);

              observer.observe(element, config);
            }, 1000);
          }
        }, 1000);
      }, 0);

      // Mobile fix for moving the translate widget depending on screen size.
      function moveTranslateWidget() {
        window.setTimeout(() => {
          const ww = window.innerWidth;
          const widget = document.getElementById("google_translate_element");
          const pp = document.getElementById(
            "google_translate_element--desktop"
          );
          const sp = document.getElementById(
            "google_translate_element--mobile"
          );

          if (!widget) {
            return;
          }

          if (ww > 991) {
            if (!pp) {
              return;
            }
            pp.append(widget);
          } else {
            if (!sp) {
              return;
            }
            sp.prepend(widget);
          }
        }, 1000);
      }

      // MoveTranslateWidget();
      window.addEventListener("DOMContentLoaded", moveTranslateWidget);
      window.addEventListener("resize", moveTranslateWidget);

      // Navbar toggle open, adjust classes.
      once("tfal-header-state", "#navbarHeader", context).forEach((element) => {
        $(element)
          .on("show.bs.collapse", () => {
            // Add the open class and add the navbar-light class.
            document.body.classList.add(navbarOpenClass);
            navBar.classList.add("navbar-light");
            header.classList.remove("sticky--scroll-active");
            // Remove any conflicting navbar-[type] classes.
            if (navBar.classList.contains("navbar-dark")) {
              navBar.classList.remove("navbar-dark");
            }
          })
          .on("hide.bs.collapse", () => {
            // Remove the open class and reset our navbar-[type].
            document.body.classList.remove(navbarOpenClass);
            navBar.classList.add(navbarBase);
            header.classList.remove("sticky--scroll-active");
          });
      });
    },
  };
})(jQuery, Drupal, once);
